import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UserDataStore, UserDataState } from './user-data.store.js';

@Injectable({ providedIn: 'root' })
export class UserDataQuery extends Query<UserDataState> {
  constructor(protected override store: UserDataStore) {
    super(store);
  }
}
